import { ReactNode } from 'react';

export function EmptyState({ icon, title, description, action }: { icon?: ReactNode; title: string; description?: string; action?: ReactNode }) {
  return (
    <div className="flex flex-col items-center justify-center gap-2 rounded-2xl border border-dashed border-ink-200 px-6 py-12 text-center">
      {icon && <div className="mb-2 text-4xl">{icon}</div>}
      <p className="text-sm font-semibold text-ink-700">{title}</p>
      {description && <p className="max-w-xs text-sm text-ink-400">{description}</p>}
      {action}
    </div>
  );
}
